/* PathRenderer.js */

"use strict";

class PathRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("path-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("PathChange", (this._onPathChange = this._onPathChange.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("PathChange");
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setPath(this._model.getPath());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onPathChange(newVal) {
        this._setPath(newVal);
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setPath(newVal) {
        if (!newVal) {
            this._rootElem.innerHTML = "/";
        } else {
            if (typeof newVal === "object") {
                const val = newVal.path || "/";
                const orgName = this._model._context.orgName;
                const pathVal = orgName ? val.replace("/" + orgName, "") : val;
                const idx = pathVal.lastIndexOf("/");
                const path = idx >= 0 ? pathVal.substring(0, pathVal.lastIndexOf("/")) || "/" : "/";
                this._rootElem.innerHTML = path;
            } else {
                const opts = this._model._context.options;
                const opt = opts.find((opt) => {
                    return opt.name === newVal;
                });
                this._rootElem.innerHTML = opt ? opt.title || "/" : "/";
            }
        }
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = PathRenderer;
